import React from 'react'
import { Flag } from 'semantic-ui-react'
import { FlagNameValues } from 'semantic-ui-react/dist/commonjs/elements/Flag/Flag'

const countries: Map<string, string> = new Map([
  ['Afghanistan', 'af'],
  ['Aland Islands', 'ax'],
  ['Albania', 'al'],
  ['Algeria', 'dz'],
  ['American Samoa', 'as'],
  ['Andorra', 'ad'],
  ['Angola', 'ao'],
  ['Anguilla', 'ai'],
  ['Antigua', 'ag'],
  ['Argentina', 'ar'],
  ['Armenia', 'am'],
  ['Aruba', 'aw'],
  ['Australia', 'au'],
  ['Austria', 'at'],
  ['Azerbaijan', 'az'],
  ['Bahamas', 'bs'],
  ['Bahrain', 'bh'],
  ['Bangladesh', 'bd'],
  ['Barbados', 'bb'],
  ['Belarus', 'by'],
  ['Belgium', 'be'],
  ['Belize', 'bz'],
  ['Benin', 'bj'],
  ['Bermuda', 'bm'],
  ['Bhutan', 'bt'],
  ['Bolivia', 'bo'],
  ['Bosnia', 'ba'],
  ['Botswana', 'bw'],
  ['Bouvet Island', 'bv'],
  ['Brazil', 'br'],
  ['British Virgin Islands', 'vg'],
  ['Brunei', 'bn'],
  ['Bulgaria', 'bg'],
  ['Burkina Faso', 'bf'],
  ['Burma', 'mm'],
  ['Burundi', 'bi'],
  ['Caicos Islands', 'tc'],
  ['Cambodia', 'kh'],
  ['Cameroon', 'cm'],
  ['Canada', 'ca'],
  ['Cape Verde', 'cv'],
  ['Cayman Islands', 'ky'],
  ['Central African Republic', 'cf'],
  ['Chad', 'td'],
  ['Chile', 'cl'],
  ['China', 'cn'],
  ['Christmas Island', 'cx'],
  ['Cocos Islands', 'cc'],
  ['Colombia', 'co'],
  ['Comoros', 'km'],
  ['Congo', 'cd'],
  ['Congo Brazzaville', 'cg'],
  ['Cook Islands', 'ck'],
  ['Costa Rica', 'cr'],
  ['Cote Divoire', 'ci'],
  ['Croatia', 'hr'],
  ['Cuba', 'cu'],
  ['Cyprus', 'cy'],
  ['Czech Republic', 'cz'],
  ['Denmark', 'dk'],
  ['Djibouti', 'dj'],
  ['Dominica', 'dm'],
  ['Dominican Republic', 'do'],
  ['Ecuador', 'ec'],
  ['Egypt', 'eg'],
  ['El Salvador', 'sv'],
  ['Equatorial Guinea', 'gq'],
  ['Eritrea', 'er'],
  ['Estonia', 'ee'],
  ['Ethiopia', 'et'],
  ['Europeanunion', 'eu'],
  ['Falkland Islands', 'fk'],
  ['Faroe Islands', 'fo'],
  ['Fiji', 'fj'],
  ['Finland', 'fi'],
  ['France', 'fr'],
  ['French Guiana', 'gf'],
  ['French Polynesia', 'pf'],
  ['French Territories', 'tf'],
  ['Gabon', 'ga'],
  ['Gambia', 'gm'],
  ['Georgia', 'ge'],
  ['Germany', 'de'],
  ['Ghana', 'gh'],
  ['Gibraltar', 'gi'],
  ['Greece', 'gr'],
  ['Greenland', 'gl'],
  ['Grenada', 'gd'],
  ['Guadeloupe', 'gp'],
  ['Guam', 'gu'],
  ['Guatemala', 'gt'],
  ['Guinea', 'gn'],
  ['Guinea-Bissau', 'gw'],
  ['Guyana', 'gy'],
  ['Haiti', 'ht'],
  ['Heard Island', 'hm'],
  ['Honduras', 'hn'],
  ['Hong Kong', 'hk'],
  ['Hungary', 'hu'],
  ['Iceland', 'is'],
  ['India', 'in'],
  ['Indian Ocean Territory', 'io'],
  ['Indonesia', 'id'],
  ['Iran', 'ir'],
  ['Iraq', 'iq'],
  ['Ireland', 'ie'],
  ['Israel', 'il'],
  ['Italy', 'it'],
  ['Jamaica', 'jm'],
  ['Jan Mayen', 'sj'],
  ['Japan', 'jp'],
  ['Jordan', 'jo'],
  ['Kazakhstan', 'kz'],
  ['Kenya', 'ke'],
  ['Kiribati', 'ki'],
  ['Kuwait', 'kw'],
  ['Kyrgyzstan', 'kg'],
  ['Laos', 'la'],
  ['Latvia', 'lv'],
  ['Lebanon', 'lb'],
  ['Lesotho', 'ls'],
  ['Liberia', 'lr'],
  ['Libya', 'ly'],
  ['Liechtenstein', 'li'],
  ['Lithuania', 'lt'],
  ['Luxembourg', 'lu'],
  ['Macau', 'mo'],
  ['Macedonia', 'mk'],
  ['Madagascar', 'mg'],
  ['Malawi', 'mw'],
  ['Malaysia', 'my'],
  ['Maldives', 'mv'],
  ['Mali', 'ml'],
  ['Malta', 'mt'],
  ['Marshall Islands', 'mh'],
  ['Martinique', 'mq'],
  ['Mauritania', 'mr'],
  ['Mauritius', 'mu'],
  ['Mayotte', 'yt'],
  ['Mexico', 'mx'],
  ['Micronesia', 'fm'],
  ['Moldova', 'md'],
  ['Monaco', 'mc'],
  ['Mongolia', 'mn'],
  ['Montenegro', 'me'],
  ['Montserrat', 'ms'],
  ['Morocco', 'ma'],
  ['Mozambique', 'mz'],
  ['Namibia', 'na'],
  ['Nauru', 'nr'],
  ['Nepal', 'np'],
  ['Netherlands', 'nl'],
  ['Netherlandsantilles', 'an'],
  ['New Caledonia', 'nc'],
  ['New Guinea', 'pg'],
  ['New Zealand', 'nz'],
  ['Nicaragua', 'ni'],
  ['Niger', 'ne'],
  ['Nigeria', 'ng'],
  ['Niue', 'nu'],
  ['Norfolk Island', 'nf'],
  ['North Korea', 'kp'],
  ['Northern Mariana Islands', 'mp'],
  ['Norway', 'no'],
  ['Oman', 'om'],
  ['Pakistan', 'pk'],
  ['Palau', 'pw'],
  ['Palestine', 'ps'],
  ['Panama', 'pa'],
  ['Paraguay', 'py'],
  ['Peru', 'pe'],
  ['Philippines', 'ph'],
  ['Pitcairn Islands', 'pn'],
  ['Poland', 'pl'],
  ['Portugal', 'pt'],
  ['Puerto Rico', 'pr'],
  ['Qatar', 'qa'],
  ['Reunion', 're'],
  ['Romania', 'ro'],
  ['Russia', 'ru'],
  ['Rwanda', 'rw'],
  ['Saint Helena', 'sh'],
  ['Saint Kitts and Nevis', 'kn'],
  ['Saint Lucia', 'lc'],
  ['Saint Pierre', 'pm'],
  ['Saint Vincent', 'vc'],
  ['Samoa', 'ws'],
  ['San Marino', 'sm'],
  ['Sandwich Islands', 'gs'],
  ['Sao Tome', 'st'],
  ['Saudi Arabia', 'sa'],
  ['Scotland', 'gb sct'],
  ['Senegal', 'sn'],
  ['Serbia', 'cs'],
  ['Seychelles', 'sc'],
  ['Sierra Leone', 'sl'],
  ['Singapore', 'sg'],
  ['Slovakia', 'sk'],
  ['Slovenia', 'si'],
  ['Solomon Islands', 'sb'],
  ['Somalia', 'so'],
  ['South Africa', 'za'],
  ['South Korea', 'kr'],
  ['Spain', 'es'],
  ['Sri Lanka', 'lk'],
  ['Sudan', 'sd'],
  ['Suriname', 'sr'],
  ['Swaziland', 'sz'],
  ['Sweden', 'se'],
  ['Switzerland', 'ch'],
  ['Syria', 'sy'],
  ['Taiwan', 'tw'],
  ['Tajikistan', 'tj'],
  ['Tanzania', 'tz'],
  ['Thailand', 'th'],
  ['Timorleste', 'tl'],
  ['Togo', 'tg'],
  ['Tokelau', 'tk'],
  ['Tonga', 'to'],
  ['Trinidad', 'tt'],
  ['Tunisia', 'tn'],
  ['Turkey', 'tr'],
  ['Turkmenistan', 'tm'],
  ['Tuvalu', 'tv'],
  ['U.A.E.', 'ae'],
  ['Uganda', 'ug'],
  ['Ukraine', 'ua'],
  ['United Kingdom', 'gb'],
  ['United States', 'us'],
  ['Uruguay', 'uy'],
  ['US Minor Islands', 'um'],
  ['US Virgin Islands', 'vi'],
  ['Uzbekistan', 'uz'],
  ['Vanuatu', 'vu'],
  ['Vatican City', 'va'],
  ['Venezuela', 've'],
  ['Vietnam', 'vn'],
  ['Wales', 'gb wls'],
  ['Wallis and Futuna', 'wf'],
  ['Western Sahara', 'eh'],
  ['Yemen', 'ye'],
  ['Zambia', 'zm'],
  ['Zimbabwe', 'zw'],
])

export default function CountryComponent(country: string) {
  const countryCode: string | undefined = countries.get(country)

  return (
    <div className="d-flex flex-row align-items-center ">
      <Flag name={countryCode as FlagNameValues} />
      <span>{country}</span>
    </div>
  )
}
